<template>
  <div class="affiliates">
    <div class="affiliates__wrap" :class="{ 'has-more': hasMore, 'has-prev': hasPrev }">
    <div
      ref="track"
      class="affiliates__track"
      tabindex="0"
      aria-label="Lista de sindicatos parceiros, role para o lado para ver mais"
      @pointerdown="startDrag"
      @pointermove="moveDrag"
      @pointerup="endDrag"
      @pointerleave="endDrag"
      @click.capture="blockClickAfterDrag"
      @scroll.passive="updateMore"
    >
    <ul class="affiliates__grid">
      <li v-for="(affiliate, index) in affiliates" :key="index">
        <a
          v-if="affiliate.url"
          :href="affiliate.url"
          target="_blank"
          rel="noopener"
          class="affiliates__item"
        >
          <span class="affiliates__logo">
            <img :src="affiliate.img" alt="" loading="lazy" />
          </span>
          <span class="affiliates__name">{{ affiliate.text }}</span>
          <span class="affiliates__hint"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" /></svg><span class="visually-hidden">Visitar site</span></span>
        </a>
        <button
          v-else
          type="button"
          class="affiliates__item"
          aria-haspopup="dialog"
          @click="openDialog(affiliate)"
        >
          <span class="affiliates__logo">
            <img :src="affiliate.img" alt="" loading="lazy" />
          </span>
          <span class="affiliates__name">{{ affiliate.text }}</span>
          <span class="affiliates__hint">Ver contatos</span>
        </button>
      </li>
    </ul>
    </div>
    <button v-if="hasPrev" type="button" class="affiliates__prev" aria-label="Ver parceiros anteriores" @click="showPrev">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
    </button>
    <button v-if="hasMore" type="button" class="affiliates__more" aria-label="Ver mais parceiros" @click="showMore">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" /></svg>
    </button>
    </div>

    <v-dialog v-model="dialog" max-width="440" content-class="affiliate-dialog">
      <div class="affiliate-dialog__body" role="document">
        <div class="affiliate-dialog__head">
          <h3 class="affiliate-dialog__title">{{ affiliate.text }}</h3>
          <button type="button" class="affiliate-dialog__close" aria-label="Fechar" @click="dialog = false">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <dl class="affiliate-dialog__list">
          <div>
            <dt>Presidente</dt>
            <dd>{{ affiliate.president }}</dd>
          </div>
          <div>
            <dt>Endereço</dt>
            <dd>{{ affiliate.address }}</dd>
          </div>
          <div>
            <dt>Email</dt>
            <dd><a :href="`mailto:${affiliate.email}`">{{ affiliate.email }}</a></dd>
          </div>
          <div>
            <dt>Telefone</dt>
            <dd>{{ affiliate.phone }}</dd>
          </div>
        </dl>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AffiliatesHome",
  methods: {
    openDialog(affiliate) {
      this.affiliate = {
        address: affiliate.address,
        email: affiliate.email,
        president: affiliate.president,
        phone: affiliate.phone,
        text: affiliate.text
      };
      this.dialog = true;
    },
    // Arraste com o mouse, com inércia: ao soltar, a faixa continua deslizando e desacelera.
    startDrag(event) {
      if (event.pointerType !== "mouse") return;
      this.cancelMomentum();
      this.justDragged = false;
      this.drag = {
        x: event.clientX,
        left: this.$refs.track.scrollLeft,
        lastX: event.clientX,
        lastT: performance.now(),
        velocity: 0,
        moved: false,
      };
    },
    moveDrag(event) {
      if (!this.drag) return;
      const now = performance.now();
      const dx = event.clientX - this.drag.x;
      if (Math.abs(dx) > 4) this.drag.moved = true;
      this.$refs.track.scrollLeft = this.drag.left - dx;
      const dt = now - this.drag.lastT;
      if (dt > 0) this.drag.velocity = (event.clientX - this.drag.lastX) / dt;
      this.drag.lastX = event.clientX;
      this.drag.lastT = now;
    },
    endDrag() {
      if (!this.drag) return;
      const { moved, velocity, lastT } = this.drag;
      this.drag = null;
      // Se o usuário parou antes de soltar, não há inércia.
      const idle = performance.now() - lastT > 100;
      if (moved) {
        // O clique vem logo após o pointerup. O flag vale só até o fim dessa tarefa.
        this.justDragged = true;
        setTimeout(() => {
          this.justDragged = false;
        }, 0);
        if (!idle && Math.abs(velocity) > 0.05) this.glide(-velocity);
      }
    },
    blockClickAfterDrag(event) {
      if (!this.justDragged) return;
      this.justDragged = false;
      event.preventDefault();
      event.stopPropagation();
    },
    glide(velocity) {
      this.cancelMomentum();
      const track = this.$refs.track;
      let v = velocity; // px por ms
      let last = performance.now();
      const step = (now) => {
        const dt = now - last;
        last = now;
        track.scrollLeft += v * dt;
        v *= Math.pow(0.95, dt / 16);
        const atEdge = track.scrollLeft <= 0 || track.scrollLeft >= track.scrollWidth - track.clientWidth;
        this.momentumId = Math.abs(v) > 0.02 && !atEdge ? requestAnimationFrame(step) : null;
      };
      this.momentumId = requestAnimationFrame(step);
    },
    // Mostra a seta e o degradê só enquanto houver parceiros além da borda visível.
    updateMore() {
      const track = this.$refs.track;
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth;
      const hasMore = track.scrollLeft < max - 4;
      const hasPrev = track.scrollLeft > 4;
      if (hasMore !== this.hasMore) this.hasMore = hasMore;
      if (hasPrev !== this.hasPrev) this.hasPrev = hasPrev;
    },
    showPrev() {
      const track = this.$refs.track;
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: reduce ? "auto" : "smooth" });
    },
    showMore() {
      const track = this.$refs.track;
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: reduce ? "auto" : "smooth" });
    },
    cancelMomentum() {
      if (this.momentumId) cancelAnimationFrame(this.momentumId);
      this.momentumId = null;
    },
  },
  mounted() {
    this.$nextTick(this.updateMore);
    window.addEventListener("resize", this.updateMore);
  },
  beforeDestroy() {
    this.cancelMomentum();
    window.removeEventListener("resize", this.updateMore);
  },
  data() {
    return {
      dialog: false,
      affiliate: {},
      drag: null,
      justDragged: false,
      momentumId: null,
      hasMore: true,
      hasPrev: false,
      affiliates: [
        {
          img: require("../../../assets/logoseebcaratinga.svg"),
          url: "http://bancarioscaratinga.org.br/plus/",
          text: "Seeb Caratinga"
        },
        {
          img: require("../../../assets/logofeebmg.svg"),
          url: "http://feebmg.org.br/",
          text: "Feeb MG, GO, TO e DF"
        },
        {
          img: require("../../../assets/logoseebcontec.svg"),
          url: "https://contec.org.br/",
          text: "Contec"
        },
        {
          img: require("../../../assets/logoseebcurvelo.svg"),
          url: "https://www.seebcurvelo.com/",
          text: "Seeb Curvelo"
        },
        {
          img: require("../../../assets/logoseebsintrafgv.svg"),
          url: "https://www.sintrafgv.com.br/",
          text: "Sintraf GV"
        },
        {
          img: require("../../../assets/logoseebitajuba.png"),
          url: "http://bancariositajuba.org.br/plus/",
          text: "Seeb Itajubá"
        },
        {
          img: require("../../../assets/logoseebituiutaba.png"),
          url: "https://www.bancariosituiutaba.org.br/",
          text: "Seeb Ituiutaba"
        },
        {
          img: require("../../../assets/logoseebmontesclaros.png"),
          url: "http://bancariosmoc.org.br/plus/",
          text: "Seeb Montes Claros"
        },
        {
          img: require("../../../assets/logooseebmuriae.png"),
          url: "http://bancariosmuriae.org.br/plus/",
          text: "Seeb Muriaé"
        },
        {
          img: require("../../../assets/logoseebpocosdecaldas.png"),
          url: "http://www.sintrafpcr.org.br/",
          text: "Seeb Poços de Caldas"
        },
        {
          img: require("../../../assets/logoseebvarginha.png"),
          url: "https://www.bancariosvarginha.org.br/",
          text: "Seeb Varginha"
        },
        {
          img: require("../../../assets/logoseebpontenova.png"),
          url: "http://bancariospnr.org.br/",
          text: "Seeb Ponte Nova"
        },
        {
          img: require("../../../assets/logoseebbarbacena.png"),
          url: "http://www.bancariosbarbacena.org.br/plus/",
          text: "Seeb Barbacena"
        },
        {
          img: require("../../../assets/logoseebsantosdumont.png"),
          url: null,
          text: "Seeb Santos Dumont",
          president: "Marcos João Couri",
          address:
            "Rua Sara Curi de Castro, nº 192 - Bairro Cabangu, 36240-000 - Santos Dumont / MG",
          phone: "(32) 3251-3764",
          email: "seebsd1963@yahoo.com.br"
        },
        {
          img: require("../../../assets/logoseebcatalao.png"),
          url: null,
          text: "Seeb Catalão",
          president: "Elciro Torquato Pereira",
          address:
            "Av. 20 de Agosto, nº 1487, Galeria Chaud - Sala 201 - Caixa Postal 151 - Centro, 75701-010 - Catalão / GO",
          phone: "(64) 3441-2964",
          email: "seebsd1963@yahoo.com.br"
        },
        {
          img: require("../../../assets/logoseebmanhuacu.png"),
          url: null,
          text: "Seeb Manhuaçu",
          president: "Maria Goretti de Oliveira Afonso Santos",
          address:
            "Rua Des. Alonso Starling, nº 346, Salas 02/03 - Centro, 36900-000 - Manhuaçu / MG",
          phone: "(33) 3331-2360",
          email: "seebmcumg@yahoo.com.br"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
// Mural de logos: grade com linhas finas compartilhadas, sem cartões nem sombras.
// Wrapper da faixa: degradê e seta única à direita, só quando há mais parceiros.
.affiliates__wrap {
  position: relative;
}

.affiliates__wrap.has-prev::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 96px;
  background: linear-gradient(to left, rgba(255, 255, 255, 0), #fff 85%);
  pointer-events: none;
  z-index: 1;
}

.affiliates__wrap.has-more::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 96px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 85%);
  pointer-events: none;
}

.affiliates__more {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid var(--c-line);
  border-radius: 50%;
  box-shadow: 0 6px 16px rgba(51, 70, 102, 0.12);
  color: var(--c-navy);
  cursor: pointer;
  transition: background-color 160ms var(--ease), color 160ms var(--ease);
}

.affiliates__prev {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid var(--c-line);
  border-radius: 50%;
  box-shadow: 0 6px 16px rgba(51, 70, 102, 0.12);
  color: var(--c-navy);
  cursor: pointer;
  transition: background-color 160ms var(--ease), color 160ms var(--ease);
}

.affiliates__prev svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.affiliates__prev:hover {
  background: var(--c-navy);
  border-color: var(--c-navy);
  color: #fff;
}

.affiliates__more svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.affiliates__more:hover {
  background: var(--c-navy);
  border-color: var(--c-navy);
  color: #fff;
}

// Faixa única de logos: rola na horizontal, com snap por item e arraste com o mouse.
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.affiliates__hint svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.affiliates__track {
  overflow-x: auto;
  scrollbar-width: none;
  cursor: grab;
  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &:active {
    cursor: grabbing;
  }

  &:focus-visible {
    outline-offset: 2px;
  }
}

.affiliates__grid {
  display: flex;
  width: max-content;
  list-style: none;
  margin: 0;
  padding: 0;
  border-top: 1px solid var(--c-line);
  border-left: 1px solid var(--c-line);
}

.affiliates__grid > li {
  flex: 0 0 216px;
  border-right: 1px solid var(--c-line);
  border-bottom: 1px solid var(--c-line);
}

.affiliates__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  height: 100%;
  min-height: 176px;
  padding: 24px 20px 20px;
  background: none;
  border: 0;
  cursor: pointer;
  color: inherit;
  font-family: var(--font-text);
  text-align: left;
  text-decoration: none;
  transition: background-color 160ms var(--ease);

  &:hover {
    background: var(--c-bg);
  }

  &:hover .affiliates__logo img {
    filter: none;
    opacity: 1;
  }

  &:hover .affiliates__hint {
    color: var(--c-navy-deep);
    text-decoration-color: currentColor;
  }
}

.affiliates__logo {
  display: flex;
  align-items: center;
  height: 64px;
  width: 100%;
  margin-bottom: 14px;

  img {
    max-width: 120px;
    max-height: 60px;
    object-fit: contain;
    filter: none;
    opacity: 1;
    transition: filter 200ms var(--ease), opacity 200ms var(--ease);
  }
}

.affiliates__name {
  font-size: var(--fs-small);
  font-weight: 600;
  line-height: 1.3;
  color: var(--c-ink);
}

.affiliates__hint {
  margin-top: auto;
  font-size: var(--fs-meta);
  color: var(--c-muted);
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 4px;
  transition: color 160ms var(--ease), text-decoration-color 160ms var(--ease);
}

@media (hover: none) {
  .affiliates__logo img {
    filter: none;
    opacity: 1;
  }
}

@media (max-width: 599px) {
  .affiliates__grid > li {
    flex-basis: 184px;
  }

  .affiliates__item {
    min-height: 156px;
    padding: 20px 14px 16px;
  }

  .affiliates__logo img {
    max-width: 100%;
  }
}
</style>

<style lang="scss">
// O diálogo é montado fora do componente (na raiz do v-app), por isso sem escopo.
.web .affiliate-dialog {
  border-radius: var(--radius);
  box-shadow: 0 24px 48px rgba(36, 50, 75, 0.28);
}

.web .affiliate-dialog__body {
  background: var(--c-surface);
  font-family: var(--font-text);
}

.web .affiliate-dialog__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 16px 20px 28px;
  background: var(--c-navy);
}

.web .affiliate-dialog__title {
  margin: 8px 0 0;
  font-family: var(--font-display);
  font-weight: 500;
  font-size: 26px;
  line-height: 1.15;
  color: #fff;
}

.web .affiliate-dialog__close {
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: none;
  border: 0;
  cursor: pointer;

  span::before,
  span::after {
    content: "";
    position: absolute;
    left: 12px;
    right: 12px;
    top: 21px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  span::before {
    transform: rotate(45deg);
  }

  span::after {
    transform: rotate(-45deg);
  }
}

.web .affiliate-dialog__list {
  margin: 0;
  padding: 8px 28px 28px;

  > div {
    padding: 16px 0;
    border-bottom: 1px solid var(--c-line);
  }

  > div:last-child {
    border-bottom: 0;
  }

  dt {
    margin-bottom: 4px;
    font-size: var(--fs-meta);
    color: var(--c-muted);
  }

  dd {
    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    color: var(--c-ink);
    overflow-wrap: anywhere;
  }

  a {
    color: var(--c-navy-deep);
  }
}
</style>
